// extracted by mini-css-extract-plugin
export var heading = "Checkout-module__heading___FAtUW";
export var li = "Checkout-module__li___b1i0B";
export var ul = "Checkout-module__ul___Nwzjh";
export var content = "Checkout-module__content___vMGYD";
export var tryArea = "Checkout-module__tryArea___M4ncV";
export var form = "Checkout-module__form___EkJ2P";
export var billedArea = "Checkout-module__billedArea____rJHW";
export var button = "Checkout-module__button___sItMs";
export var copyright = "Checkout-module__copyright___u4brk";
export var fine = "Checkout-module__fine___XY2nL";
export var billed = "Checkout-module__billed___HXFmJ";
export var after = "Checkout-module__after___hOIgG";
export var hr = "Checkout-module__hr___Amvpc";
export var coupon = "Checkout-module__coupon___2bCnR";
export var subheading = "Checkout-module__subheading___gswx2";
export var s = "Checkout-module__s___YjKVX";
export var link = "Checkout-module__link___X0kKS";
export var billedCopyright = "Checkout-module__billedCopyright___FOVHX";